import problema01 from "./cartas/problema-01.webp";
import problema02 from "./cartas/problema-02.webp";
import problema03 from "./cartas/problema-03.webp";
import problema04 from "./cartas/problema-04.webp";
import problema05 from "./cartas/problema-05.webp";
import problema06 from "./cartas/problema-06.webp";
import problema07 from "./cartas/problema-07.webp";
import problema08 from "./cartas/problema-08.webp";
import problema09 from "./cartas/problema-09.webp";
import problema10 from "./cartas/problema-10.webp";
import raroAjuda from "./cartas/raro-ajuda.webp";
import raroAmeaca from "./cartas/raro-ameaca.webp";
import solucao01 from "./cartas/solucao-01.webp";
import solucao02 from "./cartas/solucao-02.webp";
import solucao03 from "./cartas/solucao-03.webp";
import solucao04 from "./cartas/solucao-04.webp";
import solucao05 from "./cartas/solucao-05.webp";
import solucao06 from "./cartas/solucao-06.webp";
import solucao07 from "./cartas/solucao-07.webp";
import solucao08 from "./cartas/solucao-08.webp";
import solucao09 from "./cartas/solucao-09.webp";
import solucao10 from "./cartas/solucao-10.webp";

// As 22 cartas de Sudeste / Mata Atlântica — o dado, separado do
// descritor. Transcritas de Cards_Curiosidade_Sudeste02.md por
// ferramentas-da-trilha/gerar-cartas-trilha.py, e não à mão: o erro
// provável numa transcrição de 22 textos é a pílula de um card cair em
// outro, e nenhum teste pega isso.
//
// O NOME DO ARQUIVO É O ID, sem o prefixo da região (a pasta já é a
// região). `card_id` é a CHAVE da coleção do aluno em
// `activity_ludic_trail_collection` e não se renomeia depois de gravada.
//
// Sem campo `fase`: a posição na trilha vem do sorteio.

// Banco fixo de 20: o sorteio tira 4 por trilha sem repetir (ver
// ava/progressoDoAluno.js), e o tamanho do banco é o que dá chance de
// carta nova quando o aluno refaz.
export const CARDS_COMUNS_SUDESTE = [
  {
    id: "sudeste-problema-01",
    tipo: "problema",
    nome: "Desmatamento Histórico",
    asset: problema01,
    pilula:
      "A destruição da Mata Atlântica ao longo dos anos reduziu a floresta a pequenos pedaços, tirando do mico-leão-dourado o espaço de copas onde ele vive."
  },
  {
    id: "sudeste-problema-02",
    tipo: "problema",
    nome: "Fragmentação da Mata",
    asset: problema02,
    pilula:
      "Estradas e fazendas dividem a floresta, isolando pequenas famílias de mico-leão-dourado que não conseguem se encontrar pra se reproduzir."
  },
  {
    id: "sudeste-problema-03",
    tipo: "problema",
    nome: "Tráfico de Animais",
    asset: problema03,
    pilula:
      "Por causa da sua pelagem dourada e bonita, o mico-leão-dourado é capturado ilegalmente por contrabandistas pra venda como animal de estimação."
  },
  {
    id: "sudeste-problema-04",
    tipo: "problema",
    nome: "Atropelamentos em Rodovias",
    asset: problema04,
    pilula:
      "Sem árvores ligando um lado ao outro da estrada, o mico-leão-dourado é obrigado a cruzar o asfalto no chão, correndo risco grave de atropelamento."
  },
  {
    id: "sudeste-problema-05",
    tipo: "problema",
    nome: "Incêndios Florestais",
    asset: problema05,
    pilula:
      "Queimadas que atingem a Mata Atlântica queimam as copas das árvores e destroem os ocos de madeira onde o mico-leão-dourado dorme e se abriga."
  },
  {
    id: "sudeste-problema-06",
    tipo: "problema",
    nome: "Perda de Ocos de Árvores",
    asset: problema06,
    pilula:
      "O corte de árvores antigas tira da mata os ocos naturais que a família inteira do mico-leão-dourado usa pra se proteger à noite dos predadores."
  },
  {
    id: "sudeste-problema-07",
    tipo: "problema",
    nome: "Epidemias e Doenças",
    asset: problema07,
    pilula:
      "Doenças como a febre amarela atingem as populações de mico-leão-dourado, podendo eliminar grupos inteiros de uma só vez na floresta."
  },
  {
    id: "sudeste-problema-08",
    tipo: "problema",
    nome: "Especulação Imobiliária",
    asset: problema08,
    pilula:
      "O crescimento sem controle de cidades e condomínios empurra a floresta pra longe e destrói o habitat nativo do mico-leão-dourado."
  },
  {
    id: "sudeste-problema-09",
    tipo: "problema",
    nome: "Perda de Árvores Frutíferas",
    asset: problema09,
    pilula:
      "O desmatamento de árvores nativas de frutos tira do mico-leão-dourado a sua principal fonte de comida diária na mata."
  },
  {
    id: "sudeste-problema-10",
    tipo: "problema",
    nome: "Espécies Invasoras",
    asset: problema10,
    pilula:
      "Outros primatas trazidos de fora disputam o mesmo espaço, as frutas e os ocos de árvores com o mico-leão-dourado na floresta."
  },
  {
    id: "sudeste-solucao-01",
    tipo: "solucao",
    nome: "Viadutos e Pontes de Fauna",
    asset: solucao01,
    pilula:
      "Pontes de corda e viadutos florestais sobre as estradas permitem que o mico-leão-dourado atravesse as rodovias direto pelas copas sem ir ao chão."
  },
  {
    id: "sudeste-solucao-02",
    tipo: "solucao",
    nome: "Corredores Ecológicos",
    asset: solucao02,
    pilula:
      "Plantar árvores nativas conectando pedaços de mata isolados cria caminhos livres pras famílias de mico-leão-dourado se encontrarem."
  },
  {
    id: "sudeste-solucao-03",
    tipo: "solucao",
    nome: "Plantio de Frutíferas Nativas",
    asset: solucao03,
    pilula:
      "Plantar árvores nativas que dão frutos garante comida abundante o ano todo pro mico-leão-dourado e outros animais da floresta."
  },
  {
    id: "sudeste-solucao-04",
    tipo: "solucao",
    nome: "Proteção de Árvores com Ocos",
    asset: solucao04,
    pilula:
      "Preservar árvores antigas com ocos e instalar caixas-ninho garante um abrigo seguro pra família do mico-leão-dourado dormir à noite."
  },
  {
    id: "sudeste-solucao-05",
    tipo: "solucao",
    nome: "Vacinação e Saúde Animal",
    asset: solucao05,
    pilula:
      "Vacinar e monitorar o mico-leão-dourado contra doenças como a febre amarela evita epidemias e protege as populações da mata."
  },
  {
    id: "sudeste-solucao-06",
    tipo: "solucao",
    nome: "Combate ao Tráfico",
    asset: solucao06,
    pilula:
      "Aumentar a fiscalização em feiras e estradas impede a captura ilegal do mico-leão-dourado e pune o contrabando de animais."
  },
  {
    id: "sudeste-solucao-07",
    tipo: "solucao",
    nome: "Reservas Particulares (RPPN)",
    asset: solucao07,
    pilula:
      "Proprietários de terras que transformam matas em reservas protegidas garantem um lar seguro e permanente pro mico-leão-dourado."
  },
  {
    id: "sudeste-solucao-08",
    tipo: "solucao",
    nome: "Parques e Unidades de Conservação",
    asset: solucao08,
    pilula:
      "Criar parques protegidos por lei impede o desmatamento e garante grandes áreas de Mata Atlântica salvas pra vida silvestre."
  },
  {
    id: "sudeste-solucao-09",
    tipo: "solucao",
    nome: "Monitoramento por Rádio",
    asset: solucao09,
    pilula:
      "Cientistas usam pequenos colares transmissores no mico-leão-dourado pra acompanhar os grupos, novos filhotes e a saúde da espécie."
  },
  {
    id: "sudeste-solucao-10",
    tipo: "solucao",
    nome: "Educação Ambiental",
    asset: solucao10,
    pilula:
      "Ensinar crianças e comunidades sobre o mico-leão-dourado transforma os moradores locais em defensores orgulhosos da Mata Atlântica."
  }
];

// Fora do sorteio: o arco do mascote, em 1ª pessoa. A ORDEM importa, e o
// casamento é ALINHADO PELO FIM (ver nucleo/recompensaDaFase.js) — numa
// trilha de 2 a 4 passos existe uma fase rara só, e ela tem de receber o
// FECHO. O último item é o único que todo aluno vê, e o único com
// `comemorar: true`.
export const CARDS_RAROS_SUDESTE = [
  {
    id: "sudeste-raro-ameaca",
    tipo: "raro",
    nome: "Minha Mata Virou Pedaços",
    asset: raroAmeaca,
    pilula:
      "Minha floresta virou pedaços separados, e pra achar comida ou um amigo eu preciso descer no chão e cruzar a estrada. Continue a exploração pra me ajudar a proteger a Mata Atlântica!"
  },
  {
    id: "sudeste-raro-ajuda",
    tipo: "raro",
    nome: "Vamos Cuidar da Mata Atlântica!",
    asset: raroAjuda,
    comemorar: true,
    pilula:
      "Graças a você, já tem mata nova ligando os pedaços e ponte no alto pra eu não ir ao chão. Quase desapareci e estou voltando. Continue de olho: minha mata traz a chuva pra sua cidade!"
  }
];

export const CARDS_SUDESTE = [...CARDS_COMUNS_SUDESTE, ...CARDS_RAROS_SUDESTE];
